module.exports = "img/flags/SB.5550c69.png";